<!-- TODO: Add #CMS Translations -->
<div class="h-full flex flex-col justify-between">
    <div class="h-full flex flex-col justify-center gap-12">
        <div class="flex flex-col items-center justify-center gap-2">
            <img
                src="assets/images/mgo-logo-ball.svg"
                alt="MoneyGram Logo - Shape"
                class="w-16"
            />
            <img
                src="assets/images/moneygram-logo-text.svg"
                alt="MoneyGram Logo - Text"
            />
        </div>
        <div class="flex flex-col font-['Roboto'] items-center justify-center">
            <p class="font-bold text-2xl">Welcome</p>
            <p class="text-[#737373] text-base text-center max-w-80">Log in or sign up to cash-in and cash-out of USDC with MoneyGram</p>
        </div>
    </div>
    <div class="flex flex-col gap-8 pb-12">
        <div class="flex gap-4 justify-center">
            <button (click)="handleLogin()" class="sign-in-red-btn-outlined">Log In</button>
            <button (click)="handleRegister()" class="sign-in-red-btn-filled bg-red">Sign up</button>
        </div>
        <div class="flex gap-2 justify-center">
            <button 
                (click)="continueWithoutLogIn()"
                class="font-['Roboto'] text-[#333333] font-bold text-sm border-none bg-white rounded-full flex gap-2 items-center"
            >
                Continue without log in
                <img
                    src="assets/images/continue-arrow.svg"
                    alt="MoneyGram Logo - Text"
                />
            </button>
        </div>
        <!-- Todo: Remove: -->
        <!-- <div class="flex gap-4 justify-center">
            <button (click)="login()">Login</button>
            <button (click)="logout()">Logout</button>
        </div>
        <p> {{ user?.uid ? 'logged in' : 'logged out' }} </p> -->
    </div>
</div>
